/**
 * @group Contact
 * @summary Social links
 * 
 * @remarks
 * This constant contains the social media and communication links for the company,
 * including email and WhatsApp links with pre-filled messages.
 * 
 * @example
 * ```typescript
 * import { SOCIAL_LINKS } from '@shared/constants';
 * 
 * SOCIAL_LINKS.forEach(link => {
 *   const anchor = document.createElement('a');
 *   anchor.href = link.href;
 *   anchor.textContent = link.label;
 *   document.body.appendChild(anchor);
 * });
 * ```
 */
export const SOCIAL_LINKS = [
  {
    href: `mailto:help@domain.co.za`,
    label: "Email"
  },
  {
    href: `https://api.whatsapp.com/send?phone=0000000000&text=${encodeURIComponent("Hello, I'm interested in your services. Can you please provide me with more information?")}`,
    label: "WhatsApp"
  }
] as const; 